import type { XhExp } from "../types/xh";

export function formatXhExperiments(xhExperimentsRaw: string): XhExp[] | undefined {
    if (!xhExperimentsRaw) {
        return undefined;
    }

    try {
        const decodedData = decodeURIComponent(xhExperimentsRaw);
        const parsedData = JSON.parse(decodedData) as Record<string, { group: string; version: number | string }>;
        return Object.keys(parsedData).map((id) => {
            const vals = parsedData[id];

            return {
                type: id,
                v: vals.version,
                g: vals.group,
            };
        });
    } catch (_e) {
        return undefined;
    }
}